import React, { useEffect, useState } from "react";
import classNames from "classnames";
import styles from "./Flag.scss";
import { getCountryByIso } from "../../../utils/countryUtil";

export const Flag = ({ code = "_unknown", large, muted, className }) => {
    const [flagFile, setFlagFile] = useState(null);

    useEffect(() => {
        const importFlag = async () => {
            try {
                const flagFile = await import(
                    `../../../assets/images/flags/${!code ? "_unknown" : code.toLowerCase()}.svg`
                );
                setFlagFile(flagFile.default);
            } catch (err) {
                const flagFile = await import(`../../../assets/images/flags/_unknown.svg`);
                setFlagFile(flagFile.default);
                console.info("[VP]: Missing flag: " + code, err);
            }
        };
        importFlag();
    }, [code]);

    return (
        <div
            className={classNames(
                styles.base,
                {
                    [styles.large]: large,
                    [styles.muted]: muted
                },
                className
            )}
            style={{ height: `${large ? 64 : 24}px` }}
            title={code ? getCountryByIso(code)?.name : null}
        >
            <img alt={code} className={styles.image} src={flagFile} />
        </div>
    );
};
